import React from 'react';
import Projects from "../../api/projects";
import { Link } from 'react-router-dom';


import arrow from '../../images/right-arrow-2.svg';




const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const ProjectSectionS3 = (props) => {



    return (
        <section className={"" + props.hclass}>
            <div className="container-fulid">
                <div className="title">
                    <div className="project-title scroll-text-animation" data-animation="fade_from_bottom">
                        <h2>Our Feature Projects</h2>
                        <p>Leveraging advanced tools and techniques, Blaze ensures
                            precision and efficiency.</p>
                    </div>
                    <div className="project-allBtn scroll-text-animation" data-animation="fade_from_bottom">
                        <Link onClick={ClickHandler} to="/projects" className="theme-btn"><span className="rolling-text">See All Products</span>
                            <img src={arrow} alt="" /></Link>
                    </div>
                </div>
                <div className="sortable-gallery">
                    <div className="gallery-filters"></div>
                    <div className="row gallery-container">
                        {Projects.slice(8, 12).map((project, item) => (
                            <div className="col col-lg-6 col-12 scroll-text-animation" data-animation="fade_from_bottom" key={item}>
                                <div className="project-card-s3">
                                    <div className="image">
                                        <img src={project.pimg} alt="" />
                                        <img src={project.pimg} alt="" />
                                    </div>
                                    <div className="content">
                                        <h2><Link onClick={ClickHandler} to={`/project-single/${project.slug}`}>{project.title}</Link></h2>
                                        <span>{project.subtitle}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProjectSectionS3;